import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 232.25 160.79' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M0 0v160.79h232.25V0zm118.63 8h80.52v144.79h-80.52zm-5 144.79H33.11V8h80.52zM8 8h20.11v144.79H8zm216.25 144.79h-20.11V8h20.11z'
        fill='undefined'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/GabbiaIcon.js